export default "__VITE_ASSET__DC4b4RRn__"